<template>
	<component
		class="eia-heading"
		:is="tagName">
		<slot></slot>
	</component>
</template>

<script>
export default {
	name: 'eia-heading',
	props: {
		level: {
			type: String,
			default: 'h1',
			validator( value ) {
				return value.match( /h1|h2|h3|h4|h5|h6/ );
			},
		},
	},

	computed: {
		tagName() {
			return this.level;
		},
	},
};
</script>

<style lang="scss" scoped>
.eia-heading {
	color: $color-main;
	font-family: $font-family;
	font-weight: $weight-bold;
	line-height: 1.25;
	margin: 0 0 0.5em 0;
	padding: 0;

	&h1 {
		font-size: $text-h1;
	}

	&h2 {
		font-size: $text-h2;
	}

	&h3 {
		font-size: $text-h3;
	}

	&h4 {
		font-size: $text-headline;
	}

	&h5 {
		font-size: $text-subheading;
	}

	&h6 {
		font-size: $text-subheading-small;
	}
}
</style>
